import type { IDentalChart } from '@dataTypes/chartingFeature.types'

type DentalEditSessionState = {
  isDentalUpdated: boolean
  selectedDentalChart: IDentalChart | null
}

// The history grid reselects the active chart when the dental pane remounts;
// that must not end an unsaved edit session.
export const isProgrammaticReselectOfEditSession = (
  isInteracted: boolean | undefined,
  chartId: string | undefined,
  charting: DentalEditSessionState,
): boolean =>
  !isInteracted &&
  charting.isDentalUpdated &&
  Boolean(chartId) &&
  charting.selectedDentalChart?.chart_id === chartId
